import { API, axiosBaseQuery } from "app/auth/base";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";
import { createApi } from "@reduxjs/toolkit/query/react";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "app/auth/useAuth";
import { saveAs } from "file-saver";
import moment from "moment";
import store from "app/store";
import { IResponseGetTrackingTransportador } from "../slices/models";

const msalInstance = new PublicClientApplication(msalConfig);

const validateStatus = (response, result) => {
  if (response.status === 401 || response.status === 403) {
    msalInstance.logoutRedirect(loginRequest);
  }
  return response.status === 200 && !result.isError;
};

const transformResponse = (response) => {
  if (response.hasOwnProperty("items")) {
    if (response.items.length) return response.items;
    return [];
  }
  return [];
};

export const insumosApi = createApi({
  reducerPath: "buscaDeInsumosApp/buscaDeInsumos/insumosApi",
  baseQuery: axiosBaseQuery(),
  endpoints: (builder) => ({
    getDataPedido: builder.query({
      query: (data) => ({
        url: "/consulta/pedido",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataPreDetalhes: builder.query({
      query: (data) => ({
        url: "/consulta/pedido/detalhe/nota/itens",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataDetalhesCliente: builder.query({
      query: (data) => ({
        url: "/consulta/pedido/detalhe/cliente",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataDetalhesEntrega: builder.query({
      query: (data) => ({
        url: "/consulta/pedido/detalhe/entrega",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataDetalhesNota: builder.query({
      query: (data) => ({
        url: "/consulta/pedido/detalhe/nota",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataDetalhesItensDaNota: builder.query({
      query: (data) => ({
        url: "/consulta/pedido/detalhe/nota/itens",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataDetalhesTracking: builder.query({
      query: (data) => ({
        url: "/consulta/pedido/detalhe/tracking",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getDataTrackingTransportador: builder.query({
      query: (data) => ({
        url: "/edi/pedidos-ocorrencias",
        params: data,
        validateStatus,
      }),
      transformResponse: (response: IResponseGetTrackingTransportador) => {
        const lista = response.lista;
        const pedidos = lista.length ? lista[0].pedidos : [];
        return {
          pedidos,
          pagination: {
            itensPorPagina: response.itensPorPagina,
            pagina: response.pagina,
            totalItens: response.totalItens,
            totalPaginas: response.totalPaginas,
          },
        };
      },
    }),
    getDataPackJuridico: builder.query({
      query: (data) => ({
        url: "/consulta/juridico",
        params: data,
        validateStatus,
      }),
      transformResponse,
    }),
    getPDF: builder.query({
      queryFn: async (data: {
        numeroPedidoOnline: number;
        identificadorEntregaFront: number;
        tipoPedido: string;
      }) => {
        try {
          const response = await API.get("/consulta/pedido/detalhe/pdf", {
            params: data,
            responseType: "blob",
          });
          saveAs(
            response.data,
            `${data.numeroPedidoOnline}-${
              data.identificadorEntregaFront
            }-${moment().format("DD.MM.YY")}.pdf`
          );
        } catch (err: any) {
          store.dispatch(
            openModalError({
              title: "Erro ao fazer o download do PDF",
              text:
                data.tipoPedido === "OSE"
                  ? "São aceitos pedidos dos tipos STD ou PVE."
                  : "Entre em contato com o suporte. Não foi possível fazer o download do pdf",
              btnLabel: "Voltar",
            })
          );
          console.error(err.response);
        }
        return { data: null };
      },
    }),
  }),
});

export const {
  useGetDataPedidoQuery,
  useGetDataPreDetalhesQuery,
  useGetDataDetalhesClienteQuery,
  useGetDataDetalhesEntregaQuery,
  useGetDataDetalhesNotaQuery,
  useGetDataDetalhesItensDaNotaQuery,
  useGetDataDetalhesTrackingQuery,
  useGetDataPackJuridicoQuery,
  useGetDataTrackingTransportadorQuery,
} = insumosApi;
